import { z } from 'zod'

export const paymentQueueMessageResponseSchema = z.discriminatedUnion('status', [
  z.object({
    status: z.literal('success'),
  }),
  z.object({
    status: z.literal('error'),
    error: z.string(),
  }),
])
